import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Authorizer from '../../components/Authorizer/Authorizer';
import Header from '../../components/Header/Header';
import ModalOkCancel from '../../components/ModalOkCancel/ModalOkCancel';
import SideMenu from '../../components/SideMenu/SideMenu';
import { useDirectFeatureFlag } from '../../hooks/use-feature-flag.hook';
import { useStore } from '../../hooks/use-store';
import { DEPLOYMENT_FEATURE_FLAG_NAME } from '../../types/feature-flags';
import './BaseLayout.scss';

type LayoutProps = { children: any };

const BaseLayout = observer((props: LayoutProps) => {
  const { children } = props;
  const store = useStore().globalStore;
  const navigate = useNavigate();

  const isDeployment = useDirectFeatureFlag(DEPLOYMENT_FEATURE_FLAG_NAME);

  useEffect(() => {
    if (isDeployment === true) {
      navigate('/deployment');
    }
  }, [isDeployment, navigate]);

  useEffect(() => {
    void store.init(navigate);
  }, [navigate, store]);

  return (
    <div className={`base-layout ${store.isLoading ? 'show-skeletons' : ''}`}>
      <Header />
      <SideMenu />
      <div className='base-layout-content'>
        <Authorizer>{children}</Authorizer>
      </div>
      <ModalOkCancel {...store.globalModalProps} />
    </div>
  );
});

export default BaseLayout;
